export function capitalizeFirstLetter(value) {
  if (typeof value !== "string") return null;
  return value
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
